import React from 'react';
import './loader.css';

// The one loading state (DESIGN.md "Loading"): five bars in Nexxup's
// spectrum - the XX logo's green, teal, blue, indigo and purple - rising and
// falling like a meter reading, with what's loading in a Space Mono label.
//   size "page"   fills the screen under the site header: a route opening, a
//                 profile or an account loading (the default)
//        "block"  a padded block inside a page, panel or card
//        "inline" small, beside its text in a sentence, row or list; `label`
//                 is that text as written ("Loading top fans…")
// It fades in after a beat, so a load that's over in a blink never flashes
// it. With reduced motion the bars stand still, stepping up like a meter.
export default function Loader({ label = 'Loading', size = 'page', className = '' }) {
  const bars = (
    <span className="nx-loader-bars" aria-hidden="true">
      <span /><span /><span /><span /><span />
    </span>
  );
  if (size === 'inline') {
    return (
      <span className={`nx-loader is-inline${className ? ` ${className}` : ''}`}>
        {bars}
        <span className="nx-loader-text">{label}</span>
      </span>
    );
  }
  return (
    <div className={`nx-loader is-${size}${className ? ` ${className}` : ''}`} role="status">
      {bars}
      <p className="nx-loader-label">{label}</p>
    </div>
  );
}
